

























import { Prop, Component, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import chartsMixin from "./chartsMixin";
import { DataSet, ChartOptions, MyOptions } from "@/charts/graphData";
import jsonURL from "@/shared/urls";
import LineChart from "@/charts/LineChart.vue";
import moment from "moment/moment";
import MyMixin from "@/mixins/datemixin";

@Component({
  components: {
    LineChart,
  },
})
export default class CaGraph extends mixins(chartsMixin, MyMixin) {
  public dataGetted = false;
  public requestEnCours = false;
  public labels: Array<Date> = [];
  public data: Array<DataSet> = [];
  public options: ChartOptions = new ChartOptions();
  public config: any;

  @Prop() public myOptions!: MyOptions;

  @Watch("myOptions", { immediate: true, deep: true })
  public onPropertyChanged(value: any, oldValue: any) {
    if (this.myOptions && this.myOptions.site !== undefined) {
      this.init();
    }
  }

  public init() {
    // console.log("init bk line graph " + this.dataGetted);
    if (this.requestEnCours) {
      return;
    }
    this.dataGetted = false;
    this.requestEnCours = true;
    this.data = new Array();
    this.labels = new Array();
    this.config = {
      site: this.myOptions.site[0],
      date: moment(this.myOptions.date).format("YYYY-MM-DD"),
    };
    this.updateWs();
    this.orderConfig();
    this.$store
      .dispatch("home/getGraphData", { config: this.config, p: 0 })
      .then((data: any) => {
        if (this.myOptions.periode === "J") {
          data = this.quartFilter(data);
        }
        this.orderData(data, 0);
        this.setOptions();
        this.$store
          .dispatch("home/getGraphData", { config: this.config, p: 1 })
          .then((data2: any) => {
            if (this.myOptions.periode === "J") {
              data2 = this.quartFilter(data2);
            }
            this.requestEnCours = false;
            this.orderData(data2, 1);
            this.setOptions();
            if (this.myOptions.periode === "J") {
              this.$store
                .dispatch("home/getGraphData", { config: this.config, p: 2 })
                .then((data3: any) => {
                  if (this.myOptions.periode === "J") {
                    data3 = this.quartFilter(data3);
                  }
                  this.orderData(data3, 2);
                });
            }
          });
      });
  }
  /**
   *
   */
  private orderConfig(): any {
    this.orderTitre(this.myOptions, "CA HT (€)");
  }

  private updateWs() {
    switch (this.myOptions.periode) {
      case "J":
        this.config.WS = jsonURL.updateCAHTParQuartSurJour;
        this.config.dateLastWeek = moment(this.myOptions.date)
          .subtract(1, "w")
          .format("YYYY-MM-DD");
        this.config.dateLastYear = this.getSameDayLastYear(
          this.myOptions.date
        ).format("YYYY-MM-DD");
        break;
      case "SEMAINE":
        this.config.WS = jsonURL.updateCAHTParJourSurSemaine;
        this.config.dateLastWeek = moment(this.myOptions.date)
          .subtract(1, "year")
          .format("YYYY-MM-DD");
        break;
      case "MOIS":
        this.config.WS = jsonURL.updateCAHTParJourSurMois;
        this.config.dateLastWeek = moment(this.myOptions.date)
          .subtract(1, "year")
          .format("YYYY-MM-DD");
        break;
      case "ANNEE":
        this.config.WS = jsonURL.updateCAHTParMoisSurAnnee;
        this.config.dateLastWeek = moment(this.myOptions.date)
          .subtract(1, "year")
          .format("YYYY-MM-DD");
        break;
    }
  }
  /**
   * methode permettant de mettre à jour les options du graphique
   */
  private setOptions() {
    this.options.showLegend(true);
    this.options.setTitleTxt(this.titre);
    this.options.updateLegendPeriod(this.myOptions.periode);
    this.options.hideLabelPlugin();
  }

  private orderData(lignes: any, type: number) {
    let labels = [];
    const data = new Array();
    labels = Object.keys(lignes);
    labels.forEach((label: string) => {
      const mylabel =
        moment(label).toDate() !== undefined ? moment(label).toDate() : "";
      if (mylabel !== "") {
        // console.log(this.labels.length, labels.length);
        if (this.labels.length >= labels.length) {
          // DO NOTHING
          // console.log("pas push--", mylabel);
        } else {
          this.labels.push(mylabel);
        }
      }
      data.push(lignes[label]);
      // data.push(this.getRandomInt(150));
    });

    const dataSet = new DataSet();
    dataSet.typePeriode = this.myOptions.periode;
    dataSet.data = data;
    dataSet.borderColor = this.colorsComplex[type].borderColor;
    dataSet.backgroundColor = this.colorsComplex[type].backgroundColor;
    // dataSet.periodeLabels = labels;

    switch (type) {
      case 0:
        dataSet.label = this.formatDatePeriode(moment(this.config.date));
        break;
      case 1:
        dataSet.label = this.formatDatePeriode(
          moment(this.config.dateLastWeek)
        );
        break;
      case 2:
        dataSet.label = this.formatDatePeriode(
          moment(this.config.dateLastYear)
        );
        break;
    }
    // console.log("labels ", labels);
    this.data.push(dataSet);
    // console.log(this.data);
    this.dataGetted = true;
  }

  private formatDatePeriode(momDate: any) {
    let dateStr = "";
    switch (this.myOptions.periode) {
      case "J":
        dateStr = moment(momDate).format("DD/MM/YYYY");
        break;
      case "SEMAINE":
        dateStr =
          this.$t("Sem.").toString() + " " + moment(momDate).format("w YYYY");
        break;
      case "MOIS":
        dateStr = moment(momDate).format("MM/YYYY");
        break;
      case "ANNEE":
        dateStr = moment(momDate).format("YYYY");
        break;
    }

    return dateStr;
  }

  private getRandomInt(max: number) {
    return Math.floor(Math.random() * max);
  }
}
